// 主框主页面
<template>
    <!--<div @mousemove="moveEvent" class="homediv">-->
    <div class="homediv">   
    <el-container>
        <!--header部分-->
        <el-header style="height: 90px;">
            <el-form :model="userInfo" size="mini">
                <el-row>
                    <el-col :xs="3" :sm="2" :md="2" :lg="2" :xl="2">
                        <!--<a href="#" class="logo"><img :src="imglogo" alt=""></a>-->
                    </el-col>
                    <el-col :xs="15" :sm="8" :md="8" :lg="8" :xl="5">
                        <div class="web-title fl" title="乐蒂斯珠宝管理系统">乐蒂斯珠宝管理系统</div>
                    </el-col>
                    <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6" class="tar hidden-md-and-down">
                        <div>
                            <span class="red">{{userInfo.dept}},&nbsp;</span>
                            <span class="red">{{userInfo.name}}</span>
                            您好！<!--您当前的角色是
                            <span class="red">{{userInfo.role}}</span>-->
                        </div>
                    </el-col>
                    <el-col :xs="4" :sm="12" :md="12" :lg="6" :xl="6">
                        <!--
                        <el-dropdown triggle="click" @command="handleSetLang">
                            <div>选择语言</div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :disabled="language === 'zh' " command="zh">中文</el-dropdown-item>
                                <el-dropdown-item :disabled="language === 'en' " command="en">English</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        
                        更换角色
                        <el-dropdown @command="handleCommand" style="line-height:20px; cursor: pointer;">
                            <span class="el-dropdown-link">
                                更换角色<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="a" v-if="leaderRole"><a href='javascript:void(0);'>领导</a></el-dropdown-item>
                                <el-dropdown-item command="b" v-else><a href='javascript:void(0);'>客户经理</a></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>-->
                        <!--设置-->
                        <el-button class="text-line" type="text" @click="logout">安全退出</el-button>
                        <!--<el-button class="text-line" type="text">帮助</el-button>-->
                        <el-button class="text-line hidden-md-and-down" type="text" @click="dialogTableVisible = true">修改密码</el-button>
                    </el-col>
                    <!--<el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="tar hidden-xs-and-down">
                        <el-input placeholder="请输入内容" v-model="searchInfo" size="mini" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-col>-->
                </el-row>
            </el-form>
            <div class="text e-info auto-table">
                <el-dialog title="密码设置" :visible.sync = "dialogTableVisible" @close="closeSava" width="600px" center>
                    <el-form :inline="false" :rules="rules" label-width="100px" size="small" :model="addDataForm" class="demo-form-inline" ref="addDataForm">
                        <el-form-item prop="username" label="账号：">
                            <el-input v-model="userInfo.name" placeholder="请输入" readonly></el-input>
                        </el-form-item>
                        <el-form-item prop="oldpassword" label="旧密码：">
                            <el-input type="password" v-model="addDataForm.oldpassword" placeholder="请输入旧密码"></el-input>
                        </el-form-item>
                        <el-form-item prop="newpassword" label="新密码：">
                            <el-input type="password" v-model="addDataForm.newpassword" placeholder="请输入新密码"></el-input>
                        </el-form-item>
                        <el-form-item prop="repassword" label="确认密码：">
                            <el-input type="password" v-model="addDataForm.repassword" placeholder="请再次输入新密码"></el-input>
                        </el-form-item>
                        <el-form-item class="search-but">
                            <el-button type="primary" @click="modfiyPassword">保存设置</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </div>
        </el-header>
        <!--header部分-->
        <el-container style="height:80%" id="menu_pc">
            <!--左侧边栏-->
            <el-aside :width="isCollapse? '50px':'150px'" class="tal aside-left">
                <div class="toggle-button" @click="toggleCollapse">|||</div>
                <el-menu @select="handleSelect" :unique-opened="menuOpened" :collapse="isCollapse" :collapse-transition="false"
                        :default-active="workLink" class="el-menu-vertical-demo" :router='true'
                         background-color="#2273b2" text-color="#f8fafc" active-text-color="#ffd04b">

                    <el-menu-item :index="workLink">
                        <i class="el-icon-user"></i>
                        <span slot="title">用户信息</span>
                    </el-menu-item>

                    <el-submenu :index="JSON.stringify(index)" v-for="(item, index) in menuList" v-if="item.children && userInfo.type==='1'">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span>{{item.title}}</span>
                        </template>
                        <el-menu-item-group v-if="item.children" v-for="(childItem, childIndex) in item.children" :key="childItem.id">
                            <el-menu-item :index="childItem.url">{{childItem.title}}</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item :index="item.url" v-for="(item, index) in menuList" v-if="item.children === null && userInfo.type==='1'">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.title}}</span>
                    </el-menu-item>

                    <el-submenu :index="JSON.stringify(index)" v-for="(item, index) in menuList1" v-if="item.children && userInfo.type==='2'">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span>{{item.title}}</span>
                        </template>
                        <el-menu-item-group v-if="item.children" v-for="(childItem, childIndex) in item.children" :key="childItem.id">
                            <el-menu-item :index="childItem.url">{{childItem.title}}</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item :index="item.url" v-for="(item, index) in menuList1" v-if="item.children === null && userInfo.type==='2'">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.title}}</span>
                    </el-menu-item>
                </el-menu>
            </el-aside>
            <!--主体区域-->
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
    </div>
</template>
<script>
    import util from '../common/js/util';
    import cookieOperation from '../common/js/cookieOperation';
    import imgurl from '@/assets/images/logo.png';
    const Base64 = require('js-base64').Base64;
    export default {
        data() {
            let validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    let num = util.passwordValid(value);
                    if (num < 1) {
                        callback(new Error('密码复杂度不足，必须包含数字字母'));
                    }
                    if (this.addDataForm.repassword !== '') {
                        this.$refs.addDataForm.validateField('repassword');
                    }
                    callback();
                }
            };
            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.addDataForm.newpassword) {
                    callback(new Error('两次输入密码不一致！'));
                } else {
                    callback();
                }
            };
            return {
                ismb: true,
                ispc: false,
                isiphone: true,
                imglogo: imgurl,
                // 菜单只能同时展开一个
                menuOpened: true,
                isCollapse: false,
                leaderRole: true,
                workLink: '/pzxx/personalInfo',
                // 图表
                chartColumn: null,
                nestedPies: null,
                stackedBar: null,
                // 搜索框
                searchInfo: '',
                // 设置
                dialogTableVisible: false,
                addDataForm: {
                    newpassword: '',
                    repassword: ''
                },
                timmer: '',
                // 用户信息
                userInfo: {
                    name: '',
                    type: '',
                    role: '',
                    dept: ''
                },
                rules: {
                    oldpassword: [
                        {
                            required: true,
                            message: '请输入旧密码',
                            trigger: 'blur'
                        }
                    ],
                    newpassword: [
                        {
                            required: true,
                            message: '密码为8-20位数字和英文字母组成',
                            trigger: 'blur'
                        }, {
                            max: 20,
                            message: '密码长度不能超过20位'
                        }, {
                            min: 8,
                            message: '密码长度不能低于8位'
                        }, {
                            validator: validatePass,
                            trigger: 'blur'
                        }
                    ],
                    repassword: [
                        {
                            required: true,
                            message: '密码为8-20位数字和英文字母组成',
                            trigger: 'blur'
                        }, {
                            max: 20,
                            message: '密码长度不能超过20位'
                        }, {
                            min: 8,
                            message: '密码长度不能低于8位'
                        }, {
                            validator: validatePass2,
                            required: true,
                            trigger: 'blur'
                        }
                    ]
                },
                op_time: '',
                create_timestamp: '',
                // 勾选列表
                customerSel: null,
                enterpriseSel: null,
                // 左侧导航栏
                menuList: [
                    {
                        id: '10',
                        title: '钻石管理',
                        icon: 'el-icon-goods',
                        url: '/diamond',
                        children: [{
                                id: '101',
                                title: '钻石搜索',
                                icon: 'el-icon-rank',
                                url: '/diamond/diamondInfoList'
                            },{
                                id: '102',
                                title: '添加钻石',
                                icon: 'el-icon-rank',
                                url: '/diamond/diamondInsert'
                            },{
                                id: '103',
                                title: '批量上传',
                                icon: 'el-icon-rank',
                                url: '/diamond/fileUpload'
                            },/*{
                                id: '104',
                                title: '增量上传',
                                icon: 'el-icon-rank',
                                url: '/diamond/fileIncrementUpload'
                            },*/{
                                id: '105',
                                title: '上传图片',
                                icon: 'el-icon-rank',
                                url: '/diamond/imageUpload'
                            },{
                                id: '106',
                                title: '操作日志',
                                icon: 'el-icon-rank',
                                url: '/diamond/diamondLogList'
                            }
                        ]
                    },{
                        id: '11',
                        title: '订单信息',
                        icon: 'el-icon-shopping-cart-full',
                        url: '/ordersInfoList',
                        children: null
                    },{
                        id: '13',
                        title: '客户信息',
                        icon: 'el-icon-eleme',
                        url: '/customerInfoList',
                        children: null
                    }
                ],
                menuList1: [
                    {
                        id: '10',
                        title: '钻石管理',
                        icon: 'el-icon-goods',
                        url: '/diamond',
                        children: [{
                                id: '101',
                                title: '钻石搜索',
                                icon: 'el-icon-rank',
                                url: '/diamond/diamondInfoList'
                            },{
                                id: '102',
                                title: '添加钻石',
                                icon: 'el-icon-rank',
                                url: '/diamond/diamondInsert'
                            },{
                                id: '103',
                                title: '批量上传',
                                icon: 'el-icon-rank',
                                url: '/diamond/fileUpload'
                            },/*{
                                id: '104',
                                title: '增量上传',
                                icon: 'el-icon-rank',
                                url: '/diamond/fileIncrementUpload'
                            },*/{
                                id: '105',
                                title: '上传图片',
                                icon: 'el-icon-rank',
                                url: '/diamond/imageUpload'
                            },{
                                id: '106',
                                title: '操作日志',
                                icon: 'el-icon-rank',
                                url: '/diamond/diamondLogList'
                            }/*,{
                                id: '107',
                                title: '历史数据',
                                icon: 'el-icon-rank',
                                url: '/diamond/diamondHistoryList'
                            }*/
                        ]
                    },{
                        id: '9',
                        title: '采购管理',
                        icon: 'el-icon-data-analysis',
                        url: '/procurement',
                        children: [{
                                id: '91',
                                title: '钻石调价',
                                icon: 'el-icon-rank',
                                url: '/procurement/diamondInfoList'
                            }
                            /*,{
                                id: '92',
                                title: '批量上传',
                                icon: 'el-icon-rank',
                                url: '/procurement/fileUpload'
                            }*/
                            ,{
                                id: '93',
                                title: '进销存',
                                icon: 'el-icon-rank',
                                url: '/procurement/procurement'
                            }
                            ,{
                                id: '94',
                                title: '财务报表',
                                icon: 'el-icon-rank',
                                url: '/procurement/financialReportInfoList'
                            }
                            /*,{
                                id: '93',
                                title: '历史数据',
                                icon: 'el-icon-rank',
                                url: '/procurement/diamondHistoryList'
                            }*/
                        ]
                    },{
                        id: '11',
                        title: '订单信息',
                        icon: 'el-icon-shopping-cart-full',
                        url: '/ordersInfoList',
                        children: null
                    },{
                        id: '18',
                        title: '成品管理',
                        icon: 'el-icon-medal',
                        url: '/produce/produceInfoList',
                        children: [{
                                id: '181',
                                title: '珠宝饰品',
                                icon: 'el-icon-rank',
                                url: '/produce/produceInfoList'
                            }
                        ]
                    }/*,{
                        id: '12',
                        title: '财务信息',
                        icon: 'el-icon-tickets',
                        url: '/financial/financialInfoList',
                        children: null
                    }*/,{
                        id: '13',
                        title: '客户信息',
                        icon: 'el-icon-eleme',
                        url: '/customerInfoList',
                        children: null
                    },{
                        id: '14',
                        title: '供应商信息',
                        icon: 'el-icon-s-custom',
                        url: '/suppliersInfoList',
                        children: null
                    },/*{
                        id: '15',
                        title: '钻石销售',
                        icon: 'el-icon-goods',
                        url: '/shop/diamondShopList',
                        children: null
                    },{
                        id: '16',
                        title: '购物车',
                        icon: 'el-icon-shopping-cart-full',
                        url: '/shop/shopping',
                        children: null
                    }*/
                    {
                        id: '17',
                        title: 'HK钻石信息',
                        icon: 'el-icon-shopping-bag-1',
                        url: '/hk/diamondHKInfoList',
                        children: null
                    }
                ],
            };
        },
        methods: {
            moveEvent() {
                // 修复路由检查逻辑
                if (this.$route.path !== '/login') {
                    clearTimeout(this.timmer); // 重置定时器
                    this.init();
                }
            },
            init() {
                // 先清除之前的定时器
                if (this.timmer) {
                    clearTimeout(this.timmer);
                }
                
                this.timmer = setTimeout(() => {
                    // 检查是否还在当前页面，避免重复执行
                    if (this.$route.path !== '/login') {
                        cookieOperation.cookie.delete('access_token');
                        cookieOperation.cookie.delete('userName');
                        cookieOperation.cookie.delete('userType');
                        cookieOperation.cookie.delete('permission');
                        cookieOperation.cookie.delete('company_code');
                        cookieOperation.cookie.delete('userDept');
                        sessionStorage.clear();
                        this.showMsg('登录超过60分钟，需重新登录');
                        this.$router.push('/login');
                    }
                }, 1000 * 60 * 60);
            },
            // 领导/客户经理角色切换
            handleCommand(command) {
                cookieOperation.cookie.delete('access_token');
                cookieOperation.cookie.delete('userName');
                cookieOperation.cookie.delete('userType');
                cookieOperation.cookie.delete('permission');
                cookieOperation.cookie.delete('company_code');
                cookieOperation.cookie.delete('userDept');
                sessionStorage.clear();
                this.$router.push('/login');
            },
            closeSava() {
                this.addDataForm = {};
            },
            // 获取用户信息
            getUserInfo() {
                let _this = this;
                //if (!cookieOperation.cookie.get('access_token')) {
                console.log(sessionStorage.getItem('access_token'))
                if (!sessionStorage.getItem('access_token')) {
                    _this.$router.push({path: '/login'});
                    // setTimeout(function () {
                    //    _this.errorMsg('本次操作失败，需重新登录');
                    // }, 2000);
                    // setTimeout(function () {
                    //    _this.$router.push({path: '/login'});
                    // }, 4000);
                } else {
                    // let name = document.cookie.split(';')[1].split('=')[1];
                    // let type = document.cookie.split(';')[2].split('=')[1];
                    // let dept = document.cookie.split(';')[3].split('=')[1];
                    let name = sessionStorage.getItem('userName');
                    let type = sessionStorage.getItem('userType');
                    let dept = sessionStorage.getItem('userDept');
                    // let isiphone = _this.isMobile();
                    _this.userInfo = {
                        name: name,
                        type: type,
                        dept: dept,
                        isiphone: _this.isiphone
                    };

                    if (_this.userInfo.type === '1' || _this.userInfo.type === '2' || _this.userInfo.type === '4') {
                        _this.leaderRole = false;
                        _this.workLink = '/pzxx/personalInfo';
                        _this.userInfo.role = '领导';
                        _this.$router.push('/pzxx/personalInfo');
                        _this.menuList[0].url = '/pzxx/personalInfo';
                    } else if (_this.userInfo.type === '0') {
                        _this.leaderRole = false;
                        _this.workLink = '/pzxx/personalInfo';
                        _this.userInfo.role = '员工';
                        _this.$router.push('/pzxx/personalInfo');
                        _this.menuList[0].url = '/pzxx/personalInfo';
                    } else if (_this.userInfo.type === '3') {
                        _this.leaderRole = false;
                        _this.workLink = '/pzxx/usermanage';
                        _this.userInfo.role = '超级管理员';
                        _this.$router.push('/pzxx/usermanage');
                        _this.menuList[0].url = '/pzxx/usermanage';
                    }
                }
                /*
                if(sessionStorage.getItem('userName') === null || sessionStorage.getItem('userName') === ''){
                    sessionStorage.clear();
                    _this.$router.push('/login'); // 跳转 login 登陆页面
                }*/
                /*
                if (sessionStorage.getItem('customerSel') || sessionStorage.getItem('enterpriseSel')) {
                    sessionStorage.clear();
                    _this.$router.push('/login'); // 跳转 login 登陆页面
                }*/
            },
            // 退出登录
            logout() {
                let _this = this;
                _this.$confirm('确认退出吗?', '提示', {
                    // type: 'warning'
                }).then(() => {
                    cookieOperation.cookie.delete('access_token');
                    cookieOperation.cookie.delete('userName');
                    cookieOperation.cookie.delete('userType');
                    cookieOperation.cookie.delete('permission');
                    // cookieOperation.cookie.delete('company_code');
                    cookieOperation.cookie.delete('userDept');
                    sessionStorage.clear();
                    //cookieOperation.cookie.clear();
                    _this.$router.push('/login'); // 跳转 login 登陆页面
                }).catch(() => {
                });
            },
            // 修改密码
            modfiyPassword() {
                let _this = this;
                _this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/user/modfiyPassword', {
                            username: _this.userInfo.name,
                            oldpassword: _this.addDataForm.oldpassword,
                            newpassword: _this.addDataForm.newpassword
                        }, function (res) {
                            if (res.success) {
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible = false;
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    }
                });
            },
            // 更换角色
            // change() {
                /* let _this = this;
                    cookieOperation.cookie.delete('access_token');
                    cookieOperation.cookie.delete('userName');
                    cookieOperation.cookie.delete('userType');
                    cookieOperation.cookie.delete('permission');
                    cookieOperation.cookie.delete('company_code');
                    cookieOperation.cookie.delete('userDept');
                    sessionStorage.clear();
                    _this.$router.push('/login');*/ // 跳转 login 登陆页面
            // },
            // 左侧导航点击
            handleSelect(index, indexPath, e) {
                // console.log(e);
                this.customerSel = null;
                this.enterpriseSel = null;
                this.applySel = null;
                if (indexPath.length > 1 && indexPath[0] === '/kh') {
                    if (sessionStorage.getItem('enterpriseSel')) {
                        sessionStorage.clear();
                    } else if (sessionStorage.getItem('customerSel')) {
                        this.customerSel = JSON.parse(sessionStorage.getItem('customerSel'));
                    } else {
                        this.customerSel = null;
                    }
                } else if (indexPath.length > 1 && indexPath[0] === '/qyz') {
                    if (sessionStorage.getItem('customerSel')) {
                        sessionStorage.clear();
                    } else if (sessionStorage.getItem('enterpriseSel')) {
                        this.enterpriseSel = JSON.parse(sessionStorage.getItem('enterpriseSel'));
                    } else {
                        this.enterpriseSel = null;
                    }
                }
            },
            // 自动将保留中的数据超过时间的设置成在售状态
            savaDataDateLong() {
                let _this = this;
                util.publicget('/diamond/dealDiamondyYuliu', {
                    user: _this.userInfo.name,
                }, function (res) {
                    if (res.flag) {
                        console.log(res.msg);
                        //_this.successMsg(res.msg);
                    } else {
                        console.log(res.msg);
                        //_this.errorMsg(res.msg);
                    }
                })
            },
            // 判断是pc还是移动端登录
            isMobile() {
                // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPhone,iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPhone,iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
                    return true;
                }
                return false;
            },
            isPC() {
                let type1 = sessionStorage.getItem('userType');
                // 设置显隐 4客户
                if (type1 === '4'){
                    $('#menu_mb1').show();
                    $('#menu_mb2').show();
                    document.getElementById('menu_pc').style.display = 'none';
                    // console.log(document.getElementById('menu_mb1').style.display);
                    // console.log(document.getElementById('menu_mb2').style.display);
                    // console.log(document.getElementById('menu_pc').style.display);
                    // $('.menu_pc').hide();
                    // document.getElementById('menu_mb1').style.display = '';
                    // document.getElementById('menu_mb2').style.display = '';
                    // document.getElementById('menu_pc').style.display = 'none';
                } else {
                    // $('#menu_mb1').hide();
                    // $('#menu_mb2').hide();
                    $('#menu_pc').show();
                    document.getElementById('menu_mb1').style.display = 'none';
                    document.getElementById('menu_mb2').style.display = 'none';
                    // document.getElementById('menu_pc').style.display = '';
                    // console.log(document.getElementById('menu_mb1').style.display);
                    // console.log(document.getElementById('menu_mb2').style.display);
                    // console.log(document.getElementById('menu_pc').style.display);
                }
            },
            // 控制折叠菜单栏
            toggleCollapse() {
                this.isCollapse = !this.isCollapse;
            }
        },
        mounted() {
            // 进入即默认展示90%比例
            //document.body.style.zoom = 0.80;
            this.isiphone = this.isMobile();
            // this.isPC();
            this.getUserInfo();
            
            // 只有在有登录token的情况下才启动定时器
            if (sessionStorage.getItem('access_token')) {
                this.init();
                // 添加用户操作监听
                document.addEventListener('mousemove', this.moveEvent);
                document.addEventListener('keypress', this.moveEvent);
                document.addEventListener('click', this.moveEvent);
            }
            // this.savaDataDateLong();
            // this.getLastLoginDate();
            // 关于月份： 在设置时要-1，使用时要+1
            /*
            $(function () {
                $('#calendar').calendar({
                    ifSwitch: true, // 是否切换月份
                    hoverDate: true, // hover是否显示当天信息
                    backToday: true // 是否返回当天
                });
            });
            */
        },
        beforeDestroy() {
            // 组件销毁时清理定时器和事件监听
            if (this.timmer) {
                clearTimeout(this.timmer);
            }
            document.removeEventListener('mousemove', this.moveEvent);
            document.removeEventListener('keypress', this.moveEvent);
            document.removeEventListener('click', this.moveEvent);
        }
    };
</script>

<style lang="scss" scoped>
    /*lang="scss" scoped*/
    .homediv {
        height: 100%;
    }
    /*框架部分*/
    .el-container {
        height: 100%;
    }
    .el-main {
        background-color: #f8fafc;
        color: #333;
        padding: 10px;
        margin-bottom: 30px;
    }
    .el-aside {
        width: 15%;
        color: #333;
        overflow: hidden;
    }
    .toggle-button {
        background-color: #4a5064;
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        letter-spacing: 0.2em;
        cursor: pointer;
    }
    /*全局表格样式*/
    div{
        .el-table{
            th{
                height: 26px;
                line-height: 26px;
                padding: 6px 0px;
                background: #f4f8fb;
                color: #505050;
                font-weight: bold;
                border-color: #e9ebef;
            }
            td{
                height: 20px;
                line-height: 20px;
                padding: 6px 0px;
                border-color: #e9ebef;
                &.high-risk{
                    background: red;
                    color: #fff;
                }
                &.mid-risk{
                    background: yellow;
                }
                &.small-risk{
                    background: blue;
                    color: #fff;
                }
            }
        }
        /*链接文本*/
        .text-line{
            color: #409EFF;
            cursor: pointer;
            text-decoration: underline;
            &:hover{
                color: #f56c6c;
            }
        }
        .el-button--text{
            span{
                cursor: pointer;
                text-decoration: underline;
                &:hover{
                    color: #f56c6c;
                }
            }
        }
    }
    .mailTable{
        font-size: 14px;
        td{
            height: 20px;
            line-height: 20px;
            padding: 0px 5px;
            border: #e9ebef solid 1px;
            text-align: left;
        }
        .column{
            height: 26px;
            line-height: 26px;
            padding: 0px 5px;
            background: #f4f8fb;
            color: #505050;
            font-weight: bold;
            border: #e9ebef solid 1px;
            text-align: right;
        }
    }

    /*header样式*/
    .el-header {
        background-color: #fff;
        border-bottom: #3d5e99 solid 2px;
        color: #333;
        text-align: center;
        line-height: 90px;
        padding-right: 10px;
        position: relative;
        .logo{
            width: 70px;
            img{
                margin-top: 10px;
                width: 70px;
                height: 70px;
            }
        }
        .web-title {
            font-size: 28px;
            font-weight: bold;
            color: #04375f;
        }
        .input-with-select{
            max-width: 240px;
        }
    }
    
    /*左侧导航栏*/
    .aside-left{
        background-color: #2273b2;
        border-right: #053d69 solid 1px;
        .el-menu{
            border-top: #5996c5 solid 1px;
            border-right: none;
            .el-submenu__title, .el-menu-item{
                height: 45px;
                line-height: 45px;
                font-size: 12px;
                i{
                    color: #e5eaef;
                    // 菜单图标缩进
                    margin-left: -7px;
                }
            }
            .el-submenu .el-menu-item{
                height: 40px;
                line-height: 40px;
            }
            .el-menu-item-group__title{
                padding: 0px 0px 0px 20px;
            }
        }
    }

    /*右侧边栏样式*/
    .aside-right {
        background: #f8fafc;
        .el-form-item {
            border-bottom: #ccc solid 1px;
            .el-input--mini {
                width: 26px;
                .el-input__inner {
                    padding: 0px;
                    text-align: center;
                }
            }
        }
        .content {
            overflow: hidden;
            li {
                display: block;
                clear: both;
                line-height: 30px;
            }
        }
    }
    /*主体区域card卡片样式*/
    .box-card {
        .el-card__header {
            padding: 10px 10px;
            i {
                color: #1e84ec;
            }
        }
        .el-table{
            .el-table__body-wrapper{
                overflow: hidden;
                .icon-circle{
                    display: block;
                    margin: 0px auto;
                    width: 10px;
                    height: 10px;
                    border-radius: 10px;
                    &.high{
                        background: #f56c6c;
                    }
                    &.mid{
                        background: #E6A23C;
                    }
                    &.low{
                        background: #67C23A;
                    }
                }
            }
        }
        .auto-table{
            position: relative;
            .el-table {
                .el-table__body-wrapper {
                    overflow: auto;
                }
            }
            .select-all{
                position: absolute;
                width: 55px;
                height: 40px;
                background: #f4f8fb;
                z-index: 1000;
            }
        }
        .map{
            img{
                display: block;
                clear: both;
                margin: 0px auto;
            }
        }
    }
    .red{
        color: #f56c6c;
        font-size: 14px;
    }
    .el-input--suffix .el-input__inner{
        padding-right: 16px;
    }
    /*查询模块*/
    .search-content{
        background: #f8fafc;
        border: #f1f1f1 solid 1px;
        padding: 10px;
        border-radius: 3px;
        overflow: hidden;
        .search-but{
            display: block;
            clear: both;
            text-align: center;
        }
    }
    /*主体区域顶部显示内容*/
    .mark{
        .el-button{
            a{
                color: #fff;
            }
        }
    }
    .date-img{
        position: relative;
        input, button{
            display: none;
        }
        .beatpicker{
            top:0px;
            right: 0px;
        }
    }
    
    /**移动端屏幕展示 */
    @media screen and (max-width: 748px){
        .menu-container {
            width: 100%;
            display:flex;
            justify-content: left;
        }
        .el-menu-item {
            padding-left: 0px;
            min-width: 20px;
            text-align: left;
            font-size: 12px; //菜单的字体大小
            height: 30px;
            line-height: 30px;
        }
        // 设置100，pc会充满整个屏幕
        .el-menu-demo {
            width:100%;
        }
        /*html,body{
            height: 100%;
        }
        body>.el-container {
            height: 100%;
        }
        .main {
            margin-top: -180px;
            position: relative;
            float: left;
            height: 100%;
            font-size: 14px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.30);
            transform: scale(0.30);
        }
        .web-title {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.50);
            transform: scale(0.50);
        }
        .text-line{
            margin-left: 50px;
            color: #409EFF;
            cursor: pointer;
            text-decoration: underline;
            &:hover{
                color: #f56c6c;
            }
        }*/
        .el-main {
            background-color: #f8fafc;
            color: #333;
            padding: 10px;
            margin-bottom: 0px;
        }
        /**控制菜单栏样式 
        .el-dropdown-menu__item, .el-menu-item {
            font-size: 12px;
            padding: 0 0px;
            cursor: pointer;
        }*/
        /*左侧导航栏
        .aside-left{
            background-color: #2273b2;
            border-right: #053d69 solid 1px;
            .el-menu{
                border-top: #5996c5 solid 1px;
                border-right: none;
                .el-submenu__title, .el-menu-item{
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    -webkit-transform-origin-x: 0; // 文字居左
                    -webkit-transform: scale(0.40);
                    transform: scale(0.40);
                    i{
                        color: #e5eaef;
                    }
                }
                .el-submenu .el-menu-item{
                    height: 20px;
                    line-height: 20px;
                }
                .el-menu-item-group__title{
                    padding: 0px 0px 0px 20px;
                }
            }
        }*/
        /*
        .homediv {
            position: relative;
            float: left;
            height: 100%;
        }
        .homediv {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.50);
            transform: scale(0.50);
            transform-origin: left top;
        }*/
    }
</style>



// WEBPACK FOOTER //
// src/components/homepc.vue